(function (angular) {
    'use strict';

    angular
        .module('app.privacy-policy')
        .controller('app.privacy-policy.controller', ['$scope', '$http', privacyPolicyController]);

    function privacyPolicyController($scope, $http) {
        $scope.privacyPolicyHtml = '';
        var apiUrl = environment.treatmentApiDirectUrl + 'files/public-documents/privacy-policy.html';

        $http.get(apiUrl).then(function (response) {
            $scope.privacyPolicyHtml = response.data;
        });
    }
})(angular);
